var Lifecycle;

(function (Lifecycle) {
  Lifecycle[Lifecycle["APPLICATION"] = 1] = "APPLICATION";
  Lifecycle[Lifecycle["CLASS"] = 2] = "CLASS";
  Lifecycle[Lifecycle["INSTANCE"] = 3] = "INSTANCE";
  Lifecycle[Lifecycle["NONE"] = 4] = "NONE";
})(Lifecycle || (Lifecycle = {}));

function constant(jpex, name, obj) {
  return jpex.factory(name, [], function () {
    return obj;
  }).lifecycle.application();
}

var wrapper = function wrapper(factory) {
  var wrapper = {
    lifecycle: {
      application: function application() {
        factory.lifecycle = Lifecycle.APPLICATION;
        return wrapper;
      },
      class: function _class() {
        factory.lifecycle = Lifecycle.CLASS;
        return wrapper;
      },
      instance: function instance() {
        factory.lifecycle = Lifecycle.INSTANCE;
        return wrapper;
      },
      none: function none() {
        factory.lifecycle = Lifecycle.NONE;
        return wrapper;
      }
    },
    bindToInstance: function bindToInstance() {
      if (factory.fn) {
        // @ts-ignore
        factory.fn.bindToInstance = true;
      }

      return wrapper;
    },
    dependencies: function dependencies() {
      for (var _len = arguments.length, deps = new Array(_len), _key = 0; _key < _len; _key++) {
        deps[_key] = arguments[_key];
      }

      factory.dependencies = deps;
      return wrapper;
    }
  };
  return wrapper;
};

var getType = function getType(obj) {
  return Object.prototype.toString.call(obj);
};

var isObject = function isObject(obj) {
  return getType(obj) === '[object Object]';
};
var isString = function isString(obj) {
  return typeof obj === 'string';
};
var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
var hasOwn = function hasOwn(obj, name) {
  return Object.hasOwnProperty.call(obj, name);
};
var instantiate = function instantiate(context, args) {
  // eslint-disable-next-line new-parens
  return new (Function.prototype.bind.apply(context, args))();
};
var isNode = function () {
  var _process; // eslint-disable-line no-underscore-dangle


  try {
    _process = eval('process'); // eslint-disable-line no-eval
  } catch (e) {// No process
  } // eslint-disable-next-line max-len


  return typeof _process === 'object' && _process.toString && _process.toString() === '[object process]';
}(); // eslint-disable-next-line @typescript-eslint/no-unused-vars

var unsafeRequire = function unsafeRequire(target) {
  return eval('require.main.require(target)'); // eslint-disable-line no-eval
};
var REG_COMMENTS = /\/\/(.*?)\n|\/\*([\S\s]*?)\*\//g;
var extractParameters = function extractParameters(fn) {
  var CHR_OPEN = '(';
  var CHR_CLOSE = ')';
  var CHR_ARROW = '=>';
  var CHR_DELIMETER = ',';
  var str = fn.toString(); // Remove comments

  str = str.replace(REG_COMMENTS, ''); // Find the start and end of the parameters

  var open = str.indexOf(CHR_OPEN);
  var close = str.indexOf(CHR_CLOSE);
  var arrow = str.indexOf(CHR_ARROW); // Arrow functions may or may not contain brackets

  if (arrow > -1 && (arrow < open || open < 0)) {
    str = str.substring(0, arrow).trim();

    if (!str) {
      return [];
    }

    return [str];
  } // Pull out the parameters


  str = str.substring(open + 1, close);

  if (!str) {
    return [];
  }

  return str.split(CHR_DELIMETER).map(function (s) {
    return s.trim();
  });
};
var getLast = function getLast(arr) {
  return arr[arr.length - 1];
};

function factory(jpex, name, dependencies, fn) {
  if (!isString(name)) {
    throw new Error("Factories must be given a name, but was called with [" + typeof name + "]");
  }

  if (isFunction(dependencies)) {
    fn = dependencies;
    dependencies = void 0;
  }

  if (!isFunction(fn)) {
    throw new Error("Factory " + name + " must be a [Function]");
  }

  if (dependencies) {
    dependencies = [].concat(dependencies);
  } else {
    dependencies = extractParameters(fn);
  }

  if (!dependencies.length) {
    dependencies = null;
  }

  var f = {
    fn: fn,
    dependencies: dependencies,
    lifecycle: jpex.$$defaultLifecycle
  };
  jpex.$$factories[name] = f;
  return wrapper(f);
}

function service(jpex, name, dependencies, fn) {
  if (isFunction(dependencies)) {
    fn = dependencies;
    dependencies = void 0;
  }

  if (!isFunction(fn)) {
    throw new Error("Service " + name + " must be a [Function]");
  }

  if (dependencies) {
    dependencies = [].concat(dependencies);
  } else {
    dependencies = extractParameters(fn);
  }

  function factory() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = {};

    if (factory.bindToInstance) {
      dependencies.forEach(function (key, i) {
        context[key] = args[i];
      });
    }

    args.unshift(context);
    return instantiate(fn, args);
  }

  factory.bindToInstance = false;
  return jpex.factory(name, dependencies, factory);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var JpexError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(JpexError, _Error);

  function JpexError() {
    return _Error.apply(this, arguments) || this;
  }

  return JpexError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var isValidFactory = function isValidFactory(factory) {
  if (!factory) {
    return false;
  }

  if (factory.resolved) {
    return true;
  }

  if (factory.fn && typeof factory.fn === 'function') {
    return true;
  }

  return false;
};
var getFromNodeModules = function getFromNodeModules(jpex, target) {
  // in order to stop webpack environments from including every possible
  // import source in the bundle, we have to stick all node require stuff
  // inside an eval setup
  if (!isNode) {
    return;
  }

  try {
    var value = unsafeRequire(target);
    jpex.constant(target, value);
    return jpex.$$factories[target];
  } catch (e) {
    if (e && e.message && e.message.includes("Cannot find module '" + target + "'")) {
      // not found in node modules, just continue
      return;
    }

    throw e;
  }
};
var getFactory = function getFactory(jpex, name, optional) {
  if (typeof name !== 'string') {
    throw new JpexError("Name must be a string, but recevied " + typeof name);
  }

  var factory = jpex.$$resolved[name];

  if (isValidFactory(factory)) {
    return factory;
  }

  factory = jpex.$$factories[name];

  if (isValidFactory(factory)) {
    return factory;
  }

  factory = getFromNodeModules(jpex, name);

  if (isValidFactory(factory)) {
    return factory;
  }

  if (!optional) {
    throw new JpexError("Unable to find required dependency [" + name + "]");
  }
};
var cacheResult = function cacheResult(jpex, name, factory, value, namedParameters) {
  switch (factory.lifecycle) {
    case Lifecycle.APPLICATION:
      factory.resolved = true;
      factory.value = value;
      break;

    case Lifecycle.CLASS:
      jpex.$$resolved[name] = {
        resolved: true,
        value: value
      };
      break;

    case Lifecycle.NONE:
      break;

    case Lifecycle.INSTANCE:
    default:
      namedParameters[name] = value;
      break;
  }
};
var checkOptional = function checkOptional(name) {
  if (!isString(name)) {
    return false;
  }

  var first = name[0];
  var last = getLast(name);

  if (first === '_' && last === '_') {
    return name.substring(1, name.length - 1);
  }

  return false;
};

function alias(jpex, alias, name) {
  if (isValidFactory(jpex.$$factories[name])) {
    jpex.$$factories[alias] = jpex.$$factories[name];
  } else if (isValidFactory(jpex.$$factories[alias])) {
    jpex.$$factories[name] = jpex.$$factories[alias];
  } else {
    throw new Error("Cannot create an alias for [" + name + "|" + alias + "] as it does not exist");
  }
}

var resolveOne = function resolveOne(jpex, name, localOptions, namedParameters, stack) {
  var _factory$dependencies;

  if (isObject(name)) {
    var key = Object.keys(name)[0];
    return resolveOne(jpex, key, name[key], namedParameters, stack);
  }

  if (!namedParameters) {
    namedParameters = {};
  } // Optional dependencies


  var optional = false;
  var optionalCheck = checkOptional(name);

  if (optionalCheck) {
    name = optionalCheck;
    optional = true;
  } // Check named parameters
  // if we have a named parameter for this dependency
  // we don't need to do any resolution, we can just return the value


  if (hasOwn(namedParameters, name)) {
    return namedParameters[name];
  } // Special keys


  switch (name) {
    case '$options':
      return localOptions;

    case '$namedParameters':
      // @ts-ignore
      return namedParameters;
  } // Ensure we're not stuck in a recursive loop


  if (stack.indexOf(name) > -1) {
    if (getLast(stack) === name) {
      var _jpex$$$parent;

      if ((_jpex$$$parent = jpex.$$parent) == null ? void 0 : _jpex$$$parent.$$factories[name]) {
        return resolveOne(jpex.$$parent, name, localOptions, namedParameters, []);
      }
    }

    throw new JpexError("Recursive loop for dependency " + name + " encountered");
  } // Get the factory
  // This will either return the factory,
  // return null (meaning it's an optional dependency)
  // or throw an error


  var factory = getFactory(jpex, name, optional);

  if (!factory) {
    return;
  } // Check if it's already been resolved


  if (factory.resolved) {
    return factory.value;
  } // Work out dependencies


  var args = [];

  if (factory == null ? void 0 : (_factory$dependencies = factory.dependencies) == null ? void 0 : _factory$dependencies.length) {
    try {
      // eslint-disable-next-line no-use-before-define
      args = resolveMany(jpex, factory, namedParameters, localOptions, stack.concat(name));
    } catch (e) {
      if (!optional) {
        throw e;
      }

      return;
    }
  } // Invoke the factory


  var value = factory.fn.apply(jpex, args); // Cache the result

  cacheResult(jpex, name, factory, value, namedParameters);
  return value;
};
var resolveMany = function resolveMany(jpex, definition, namedParameters, globalOptions, stack) {
  if (!(definition == null ? void 0 : definition.dependencies)) {
    return [];
  }

  if (!stack) {
    stack = [];
  }

  if (!namedParameters) {
    namedParameters = {};
  }

  var dependencies = [].concat(definition.dependencies);
  var values = dependencies.reduce(function (value, dependency) {
    if (isObject(dependency)) {
      var keys = Object.keys(dependency);

      var _x = keys.reduce(function (value, key) {
        var options = dependency[key];
        var y = resolveOne(jpex, key, options, namedParameters, stack);
        return value.concat(y);
      }, []);

      return value.concat(_x);
    }

    var x = resolveOne(jpex, dependency, globalOptions, namedParameters, stack);
    return value.concat([x]);
  }, []);
  return values;
};

var resolve = function resolve(jpex, name, namedParameters) {
  return resolveOne(jpex, name, null, namedParameters, []);
};
var resolveDependencies = function resolveDependencies(jpex, definition, namedParameters) {
  return resolveMany(jpex, definition, namedParameters, void 0, []);
};
var isResolved = function isResolved(jpex, dependency) {
  var _jpex$$$factories$dep;

  if (!isString(dependency)) {
    return false;
  }

  if (jpex.$$resolved[dependency]) {
    return true;
  }

  if ((_jpex$$$factories$dep = jpex.$$factories[dependency]) == null ? void 0 : _jpex$$$factories$dep.resolved) {
    return true;
  }

  return false;
};
var allResolved = function allResolved(jpex, dependencies) {
  return dependencies.every(isResolved.bind(null, jpex));
};

var Jpex = /*#__PURE__*/function () {
  function Jpex(options, parent) {
    var _ref;

    if (options === void 0) {
      options = {};
    }

    this.$$factories = {};
    this.$$resolved = {};
    var _options = options,
        _options$inherit = _options.inherit,
        inherit = _options$inherit === void 0 ? true : _options$inherit,
        _options$lifecycle = _options.lifecycle,
        lifecycle = _options$lifecycle === void 0 ? (_ref = inherit ? parent == null ? void 0 : parent.$$defaultLifecycle : void 0) != null ? _ref : Lifecycle.CLASS : _options$lifecycle;
    this.$$parent = parent;
    this.$$defaultLifecycle = lifecycle;

    if (parent && inherit) {
      this.$$factories = Object.create(parent.$$factories);
    }
  }

  var _proto = Jpex.prototype;

  _proto.extend = function extend(config) {
    return new Jpex(config, this);
  };

  _proto.constant = function constant$1(name, obj) {
    return constant(this, name, obj);
  };

  _proto.factory = function factory$1(name, deps, fn) {
    return factory(this, name, deps, fn);
  };

  _proto.service = function service$1(name, deps, fn) {
    return service(this, name, deps, fn);
  };

  _proto.alias = function alias$1(_alias, name) {
    return alias(this, _alias, name);
  };

  _proto.resolve = function resolve$1(name) {
    return resolve(this, name);
  };

  _proto.resolveWith = function resolveWith(name, namedParameters) {
    return resolve(this, name, namedParameters);
  };

  _proto.raw = function raw(name) {
    return getFactory(this, name, false).fn;
  };

  _proto.encase = function encase(_deps, _fn) {
    var _ref2 = function () {
      if (typeof _deps === 'function') {
        return [extractParameters(_deps), _deps];
      }

      return [_deps, _fn];
    }(),
        dependencies = _ref2[0],
        fn = _ref2[1];

    var result;
    var jpex = this;

    var encased = function encased() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      /* eslint-disable no-invalid-this */
      if (result && allResolved(jpex, dependencies)) {
        return result.apply(this, args);
      }

      var deps = resolveDependencies(jpex, {
        dependencies: dependencies
      });
      result = fn.apply(this, deps);
      return result.apply(this, args);
      /* eslint-enable */
    };

    encased.encased = fn;
    return encased;
  };

  _proto.clearCache = function clearCache(names) {
    names = [].concat(names || []);

    for (var key in this.$$factories) {
      if (!names.length || names.indexOf(key) > -1) {
        this.$$factories[key].resolved = false;
      }
    }

    for (var _key2 in this.$$resolved) {
      if (!names.length || names.indexOf(_key2) > -1) {
        delete this.$$resolved[_key2];
      }
    }
  };

  _proto.infer = function infer() {
    return '';
  };

  return Jpex;
}();

var registerResolveFactory = (function (jpex) {
  jpex.factory('$resolve', ['$namedParameters'], function ($namedParameters) {
    var _this = this;

    return function (name, namedParameters) {
      var allParams = _objectSpread2(_objectSpread2({}, $namedParameters), namedParameters);

      if (Array.isArray(name)) {
        return resolveDependencies(_this, // eslint-disable-line no-invalid-this
        {
          dependencies: name
        }, allParams);
      }

      return resolve(_this, // eslint-disable-line no-invalid-this
      name, allParams);
    };
  });
});

var jpex = new Jpex();
registerResolveFactory(jpex);

export default jpex;
export { Lifecycle, jpex };
